// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context-menu {
    background: white;
    border: 1px solid gray;
    box-shadow: 6px 6px 1px rgba(0, 0, 0, 10%);
    position: absolute;
    z-index: 10;
}

.context-menu button {
    border: none;
    display: block;
    padding: 0.5em;
    padding-top: 0.3em;
    padding-bottom: 0.3em;
    text-align: left;
    width: 100%;
    background: white;
    cursor: pointer;
}

.context-menu button:hover {
    background: #eee;
}

.context-menu-h {
    background: white;
    border: 1px solid gray;
    border-radius: 4px;
    box-shadow: 6px 6px 1px rgba(0, 0, 0, 10%);
    padding: 1px;
    position: absolute;
    z-index: 10;
    display: flex;
    flex-direction: row;
}

.context-menu-h button {
    border: none;
    display: block;
    padding: 0.5em;
    text-align: left;
    background: white;
    cursor: pointer;
}

.context-menu-h button:hover {
    background: #eee;
}`, "",{"version":3,"sources":["webpack://./src/components/flow/context-menu.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,0CAA0C;IAC1C,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".context-menu {\n    background: white;\n    border: 1px solid gray;\n    box-shadow: 6px 6px 1px rgba(0, 0, 0, 10%);\n    position: absolute;\n    z-index: 10;\n}\n\n.context-menu button {\n    border: none;\n    display: block;\n    padding: 0.5em;\n    padding-top: 0.3em;\n    padding-bottom: 0.3em;\n    text-align: left;\n    width: 100%;\n    background: white;\n    cursor: pointer;\n}\n\n.context-menu button:hover {\n    background: #eee;\n}\n\n.context-menu-h {\n    background: white;\n    border: 1px solid gray;\n    border-radius: 4px;\n    box-shadow: 6px 6px 1px rgba(0, 0, 0, 10%);\n    padding: 1px;\n    position: absolute;\n    z-index: 10;\n    display: flex;\n    flex-direction: row;\n}\n\n.context-menu-h button {\n    border: none;\n    display: block;\n    padding: 0.5em;\n    text-align: left;\n    background: white;\n    cursor: pointer;\n}\n\n.context-menu-h button:hover {\n    background: #eee;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
